import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";
import { BusinessCentralSection } from "components/BusinessCentral/BusinessCentralSection";
import { CompanyFieldMetaData, CompanyFormState } from "shared/utils/fieldsHelper/companyFields";

export const businessCentralSection = (
  companyFormState: CompanyFormState,
  fieldMetaData: CompanyFieldMetaData,
): CustomSection => {
  return {
    ...fieldMetaData.businessCentral.fields(),
    type: "custom",
    key: "businesscentralsection",
    render: () => <BusinessCentralSection
      businessCentralNumber={companyFormState.businessCentralNumber}
      companyFormState={companyFormState}
    />,
  }
}